import styled from 'styled-components';

interface innerWrapperProps {
	margin?: string;
	padding?: string;
	width?: string;
}
const InnerWrapper = styled.div<innerWrapperProps>`
	display: flex;
	margin: 0 auto;
	width: 100%;
	// max-width: 1240px !important;
	position: relative;
`;
export default InnerWrapper;
